/* eslint-disable react/jsx-props-no-spreading */
import { Box, Grid } from '@mui/material';
import React from 'react';

interface FormEndOptionsProps {
  children?: React.ReactNode;
  position?: string;
  width?: string;
  sx?: Record<string, unknown>;
}

function FormEndOptions({ children, position = 'sticky', width = '100%', ...props }: FormEndOptionsProps) {
  return (
    <Grid
      item
      xs={12}
      sx={{
        backgroundColor: 'white',
        position,
        width,
        bottom: 0,
        p: 2,
        zIndex: 2,
        borderTop: '1px solid #BDBDBD',
        ...props.sx
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'center',
          gap: 2,
        }}
        {...props}
      >
        {children}
      </Box>
    </Grid>
  );
}

export default FormEndOptions;
